import {
  ControlledInput,
  ControlledPhoneInput,
} from 'modules/common/components';
import { FormFieldWithComponent } from 'modules/common/types';
import { getTranslation } from 'utils/getTranslation';

import { ContactFields } from './enum';

const t = getTranslation('owner.CreateOwnerPage');

export const contactFields: FormFieldWithComponent<
  ContactFields,
  { name: string }
>[] = [
  {
    label: t('firstName'),
    name: ContactFields.firstName,
    Component: ({ control, name }) => (
      <ControlledInput
        placeholder={t('enterFirstName')}
        controlled={{
          control,
          name,
        }}
      />
    ),
  },
  {
    label: t('lastName'),
    name: ContactFields.lastName,
    Component: ({ control, name }) => (
      <ControlledInput
        placeholder={t('enterLastName')}
        controlled={{
          control,
          name,
        }}
      />
    ),
  },
  {
    label: t('streetAddress'),
    name: ContactFields.streetAddress,
    Component: ({ control, name }) => (
      <ControlledInput
        placeholder={t('enterStreetAddress')}
        controlled={{
          control,
          name,
        }}
      />
    ),
  },
  {
    label: t('city'),
    name: ContactFields.city,
    Component: ({ control, name }) => (
      <ControlledInput
        placeholder={t('enterCity')}
        controlled={{
          control,
          name,
        }}
      />
    ),
  },
  {
    label: t('state'),
    name: ContactFields.state,
    Component: ({ control, name }) => (
      <ControlledInput
        placeholder={t('enterState')}
        controlled={{
          control,
          name,
        }}
      />
    ),
  },
  {
    label: t('zipCode'),
    name: ContactFields.zipCode,
    Component: ({ control, name }) => (
      <ControlledInput
        placeholder={t('enterZipCode')}
        controlled={{
          control,
          name,
        }}
      />
    ),
  },
  {
    label: t('email'),
    name: ContactFields.email,
    Component: ({ control, name }) => (
      <ControlledInput
        placeholder={t('enterEmail')}
        controlled={{
          control,
          name,
        }}
      />
    ),
  },
  {
    label: t('phone'),
    name: ContactFields.phoneNumber,
    Component: ({ control, name }) => (
      <ControlledPhoneInput
        placeholder={t('enterPhone')}
        controlled={{
          control,
          name,
        }}
      />
    ),
  },
];
